export default __webpack_public_path__ + "static/media/cold-tea-ginger.b878f08f.png";